import React, {useEffect, useState} from 'react'
import { Input, Form } from 'antd'
import '../InputField/float.scss'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import {checkAmountForRequest} from "../../services/helper";
import { useTranslation } from 'react-i18next'

const AmountField = (props: any) => {
    const {t} = useTranslation()
    const [focus, setFocus] = useState(false);
    const [disabled, setDisabled] = useState<boolean>(props.disabled || false);
    const [readOnly, setReadOnly] = useState<boolean>(props.readOnly || false)
    const input_name=props.name || '';
    const input_id=`input_${input_name}`;
    const [value, setValue] = useState(props.value || '');

    useEffect(() => {
        updateValue(props.value);

        setDisabled(old_data => props.disabled || false)
        setReadOnly(old_data => props.readOnly)

    }, [props.value, props.disabled, props.readOnly])

    const updateValue = (value) => {

        if (!props.staticValue){
            setValue(old_value => value);

            if(props.form){
                props.form.setFieldsValue(
                    {
                        [input_name]: value
                    }
                );
            }
        }
    }

    const onReset = () => {

        updateValue('');

        let current_input=document.querySelector(`#${input_name}`);

        if (current_input?.classList.contains('isReadOnly')){
            setReadOnly(old_data => true)
        }

        if (current_input?.classList.contains('isDisabled')){
            setDisabled(old_data => true)
        }
    }

    const handleInputChange = (e) => {
        updateValue(e.target.value);

        if (props.onChange){
            props.onChange(e);
        }


    };

    const onBlur = (e) => {
        const value = e.target.value;

        let value1 = value !== '' && value !== undefined ? checkAmountForRequest(value) : value;
        setValue(old_value => value1);

        if(props.form){
            props.form.setFieldsValue(
                {
                    [input_name]: value1
                }
            );
        }
        if (props.onBlur){
            props.onBlur(e);
        }
    }

    let validate_message=props.message || '';

    if (props.required && !props.message){
        validate_message=t("newTransfer.requiredField");
    }

    let item_class=props?.className;

    let divClass=`custom_input_component custom_amount_component ${props?.currencyClass}`;

    if (props.readOnly){
        divClass+=' input_readonly  '
    }

    const defaultMaskOptions = {
        prefix: '',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ' ',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        integerLimit: props.limit !== null && props.limit !== undefined ? props.limit : 8,
        allowNegative: false,
        allowLeadingZeroes: false,
        ref : props.ref
    }

    const currencyMask = createNumberMask({
        ...defaultMaskOptions
    })

    return (
        <div className={divClass} >
            <Form.Item
                name={input_name}
                label={props.labelItem}
                labelCol={props.labelCol}
                wrapperCol={props.wrapperCol}
                className={`${item_class} input-field`}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                    {
                        required: props.required || false,
                        message : validate_message
                    }
                ]}
                onReset={onReset}
                shouldUpdate={(prevValues, curValues) => {

                    if (prevValues[input_name]!==curValues[input_name] && props.shouldUpdate){
                        setDisabled(old_value => false)
                    }

                    return true;
                }}
            >

                    <MaskedInput
                        name={input_name}
                        placeholder={props.placeholder}
                        value={value}

                        className={'ant-input'}
                        onChange={handleInputChange}
                        onBlur={onBlur}
                        disabled={disabled}
                        readOnly={readOnly}
                        /*id={input_id}*/
                        mask={currencyMask}
                        type={'text'}
                    />
            </Form.Item>

            <span className={'ant-input-suffix'} >{props.suffix || ''}</span>

        </div>
    )
}

export default AmountField
